import { render, staticRenderFns } from "./BillingStatistics.vue?vue&type=template&id=be806516&scoped=true&"
import script from "./BillingStatistics.vue?vue&type=script&lang=ts&"
export * from "./BillingStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./BillingStatistics.vue?vue&type=style&index=0&id=be806516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be806516",
  null
  
)

export default component.exports